export default __webpack_public_path__ + "static/media/projectClosed.da408261.svg";